import React from 'react';
import { connect } from 'react-redux';
import { func, bool } from 'prop-types';
import { reduxForm } from 'redux-form';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import AuthFormBox from 'app/components/AuthFormBox';
import UTTouchableWithoutFeedback from 'app/components/UTTouchableWithoutFeedback';
import { message } from 'utils/stringUtils';
import { SIGNUP_EMAIL_VALIDATION } from 'constants/reduxForms';
import { signUpUserInformation } from 'types/userTypes';
import { gaTrackPageView } from 'services/AnalyticsService';
import { ROUTES } from 'constants/routes';

import ReturnToSignIn from '../ReturnToSignIn';

import EmailValidation from './layout';
import styles from './styles';

class EmailValidationContainer extends React.PureComponent {
  componentDidMount() {
    gaTrackPageView(ROUTES.SIGN_UP);
  }

  render() {
    const { handleSubmit, onResendCode, loading, userInformation, submitFailed, invalid } = this.props;
    return (
      <form onSubmit={handleSubmit} style={styles.container}>
        <AuthFormBox title={message('Signup:validateEmail')}>
          <EmailValidation loading={loading} userEmail={userInformation.email} />
        </AuthFormBox>
        {!loading && [
          <UTButton disabled={submitFailed && invalid} key="submit" style={styles.submit} type="submit">
            {message('Signup:validateEmail2')}
          </UTButton>,
          <UTTouchableWithoutFeedback
            onClick={() =>
              onResendCode(
                userInformation.email,
                userInformation.document_type,
                userInformation.document_number
              )
            }
            style={styles.resendMail}
            key="resend"
          >
            <UTLabel semibold small darkGray>
              {message('Signup:missingMail')}
            </UTLabel>
            <UTLabel semibold small primary>
              &nbsp;
              {message('Signup:resend')}
            </UTLabel>
          </UTTouchableWithoutFeedback>,
          <ReturnToSignIn key="signout" />
        ]}
      </form>
    );
  }
}

EmailValidationContainer.propTypes = {
  handleSubmit: func.isRequired,
  onResendCode: func.isRequired,
  loading: bool,
  userInformation: signUpUserInformation,
  submitFailed: bool,
  invalid: bool
};

const mapStateToProps = store => ({
  userInformation: store.auth.signUpFlow.userInformation
});

export default connect(mapStateToProps)(
  reduxForm({ form: SIGNUP_EMAIL_VALIDATION })(Radium(EmailValidationContainer))
);
